export const REGISTRATIONS_ROUTES = {
  __ROOT__: "/registrations",
  REGISTRATION_DETAILS: "/registrations/get-registration-details/:id",
};
